import { logger } from '@fiverr-private/obs';
import cookieHelpers from '../../../../../lib/cookie';
import {
    REPEAT_SOLVE_COOKIE_NAME,
    REPEAT_SOLVE_COOKIE_SEPARATOR,
    EXONERATION_EXPIRATION
} from '../constants';

/**
 * Check if this user has been exonerated before the expiration
 * @param {Request} request Intercepted request
 * @returns {void}
 */
export function reportInterceptAfterSolve(request) {
    const cookies = cookieHelpers.getAll();
    const cookie = cookies && cookies[REPEAT_SOLVE_COOKIE_NAME];
    if (!cookie) {
        return;
    }

    const [ iterations, beginning ] = cookie.split(REPEAT_SOLVE_COOKIE_SEPARATOR).map(Number);
    const interval = Date.now() - beginning;
    interval < EXONERATION_EXPIRATION && logger.force.warn({
        message: `Advanced block event after challenge solve: ${iterations} in ${Math.round(interval / 1000)} seconds.`,
        interval,
        code: 'REPEAT_CHALLENGE_SOLVE',
        url: request.url,
        vid: cookies._pxvid,
        u_guid: cookies.u_guid,
        referrer: document.referrer
    });
}

/**
 * Update/add cookie on exoneration events
 * @returns {void}
 */
export function updateSolveSuccess() {
    const cookies = cookieHelpers.getAll();
    const cookie = cookies && cookies[REPEAT_SOLVE_COOKIE_NAME];
    const [
        iterations = 0,
        beginning = Date.now()
    ] = cookie
        ? cookie.split(REPEAT_SOLVE_COOKIE_SEPARATOR).map(Number)
        : [];
    const end = beginning + EXONERATION_EXPIRATION;

    cookieHelpers.set(
        REPEAT_SOLVE_COOKIE_NAME,
        [iterations + 1, beginning].join(REPEAT_SOLVE_COOKIE_SEPARATOR),
        {
            expires: new Date(end),
            maxAge: Math.floor((end - Date.now()) / 1000),
            domain: '.fiverr.com',
            path: '/',
            sameSite: 'none', // cross-origin
            secure: true
        }
    );
}
